import React from 'react';
import FormHelperText from '@material-ui/core/FormHelperText';

interface Props {
  text?: string;
  error?: string;
  dataTest: string;
  className?: string;
  style?: React.CSSProperties;
  hideWhenEmpty?: boolean; // by default we preserve some space to prevent content moving when an error occurs
}

export const HelpText: React.FC<React.PropsWithChildren<Props>> = ({
  text,
  error,
  dataTest,
  className,
  hideWhenEmpty,
  style
}) => {
  const shouldHide = hideWhenEmpty && (!text || text === ' ') && !error;
  if (shouldHide) {
    return null;
  }
  return (
    <FormHelperText
      error={!!error}
      data-test={`${dataTest}-field-helper`}
      id={`${dataTest}-helper-text`}
      className={className}
      style={style}
    >
      {error || text}
    </FormHelperText>
  );
};
